import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgCamera = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      d="M15.923 12.822a3.746 3.746 0 1 1-7.491 0 3.746 3.746 0 0 1 7.491 0"
      fill={props.color}
    />
    <Path
      clipRule="evenodd"
      d="M7.04 3.365c.375-.697.832-1.543 1.777-1.543h6.72c.954 0 1.442.698 1.83 1.561a.77.77 0 0 0 .696.439h3.114a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-18a2 2 0 0 1-2-2v-14a2 2 0 0 1 2-2h3.095a.87.87 0 0 0 .758-.439zm10.683 9.457a5.546 5.546 0 1 1-11.091 0 5.546 5.546 0 0 1 11.091 0"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgCamera);
export default Memo;
